import { render, staticRenderFns } from "./RUS.vue?vue&type=template&id=3d86c811&scoped=true&"
import script from "./RUS.vue?vue&type=script&lang=js&"
export * from "./RUS.vue?vue&type=script&lang=js&"
import style0 from "./RUS.vue?vue&type=style&index=0&id=3d86c811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86c811",
  null
  
)

export default component.exports